var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.07507 13.8408C6.53946 14.3517 7.33002 14.3893 7.84084 13.9249C8.35166 13.4605 8.38931 12.67 7.92493 12.1592L6.07507 13.8408ZM2 7.5L1.07508 6.65916L0.310675 7.5L1.07508 8.34084L2 7.5ZM7.92493 2.84084C8.38931 2.33002 8.35166 1.53946 7.84084 1.07507C7.33002 0.610691 6.53946 0.648336 6.07508 1.15916L7.92493 2.84084ZM7.92493 12.1592L2.92493 6.65916L1.07508 8.34084L6.07507 13.8408L7.92493 12.1592ZM2.92493 8.34084L7.92493 2.84084L6.07508 1.15916L1.07508 6.65916L2.92493 8.34084Z",
    fill: "#FF7B72"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftVector);
export default __webpack_public_path__ + "static/media/LeftVector.1637366099318e457f47aa1c2b1e64bd.svg";
export { ForwardRef as ReactComponent };